module.exports = __webpack_public_path__ + "assets/icon-dislike-component.3f5f2ae1.svg";